import { render } from "./SearchClear.vue?vue&type=template&id=6176d767"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/SearchClear.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6176d767"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6176d767', __exports__)) {
    api.reload('6176d767', __exports__)
  }
  
  module.hot.accept("./SearchClear.vue?vue&type=template&id=6176d767", () => {
    api.rerender('6176d767', render)
  })

}


export default __exports__